import React, { useState } from "react";

export default function AllergensToggle({ product, dark = false }) {
  const [open, setOpen] = useState(false);
  if (!product.allergens) return null;
  const tone = dark ? "text-[#0C0C0C]/70 hover:text-[#0C0C0C]" : "text-white/50 hover:text-[#FFC20E]";
  return (
    <div className="mt-2">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        className={`font-display font-bold uppercase tracking-[0.2em] text-[11px] transition-colors duration-200 ${tone}`}
        data-testid={`allergens-toggle-${product.slug}`}
      >
        ALLERGENI {open ? "−" : "+"}
      </button>
      {open && (
        <p className={`mt-1 text-xs leading-snug ${dark ? "text-[#0C0C0C]/80" : "text-white/60"}`} data-testid={`allergens-text-${product.slug}`}>
          {product.allergens}
        </p>
      )}
    </div>
  );
}
